import MarketingLocale from '@shared/ui/marketing-locale/MarketingLocale';
import MarketingFooter from '@/marketing/components/Footer';

/**
 * Funnel footer = the real marketing `Footer`, reused verbatim inside the
 * marketing locale context (see `MarketingLocale`).
 */
export default function Footer() {
  return (
    <MarketingLocale>
      <MarketingFooter />
    </MarketingLocale>
  );
}
